import { useEffect, useState } from 'react';
import { performanceMonitor } from '@/utils/performanceMonitor';

/**
 * Hook to access performance metrics in components
 */
export function usePerformanceMetrics() {
  const [metrics, setMetrics] = useState(performanceMonitor.getMetrics());

  useEffect(() => {
    // Update metrics every 2 seconds
    const interval = setInterval(() => {
      setMetrics(performanceMonitor.getMetrics());
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return {
    metrics,
    navigationTiming: performanceMonitor.getNavigationTiming(),
  };
}

/**
 * Hook to measure component mount time
 */
export function useComponentLoadTime(componentName: string) {
  useEffect(() => {
    const startTime = performance.now();
    
    return () => {
      const loadTime = performance.now() - startTime;
      performanceMonitor.recordMetric(`${componentName}_Load`, loadTime);
    };
  }, [componentName]);
}
